import script from "./ProductCategoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCategoryPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductCategoryPage.vue?vue&type=style&index=0&id=1b9c5abc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9c5abc"]])

export default __exports__